/**
 * Adjuntos de pago
 *
 */
import React from 'react'
import { Table, Button, Modal, message, Icon, Row, Col } from 'antd'
import moment from 'moment'
import Cell from '../../../components/Cell'
import Api from '../../../Api'
import Exception from '../../../Exception'
import Crud from '../../../components/Crud'

export default class Adjuntos extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    // this.requestNewFile(record, record.sFiltro)
    this.columns = Cell.buildList([
      {
        title: 'NOMBRE', dataIndex: 'archivo.sDescripcion', width: '60%',
        render: (_, record) => <span>
          <a href={Api.to(`/upload/file/${record.iIdArchivo}`)} download={record.archivo.sDescripcion}>
            {record.archivo.sDescripcion}
          </a>
        </span>
      },
      { title: 'FECHA', dataIndex: 'archivo.dFechahora', width: '30%', render: val => moment(val).format('YYYY-MM-DD HH:mm:ss') },
      { title: (<Icon type='block' style={{ fontSize: 20 }} />), dataIndex: 'archivo.dFechahora', width: '10%', render: (_, record) => !this.state.cotizacionPendiente ? null : (
        <Button
          icon='delete'
          shape='circle-outline'
          onClick={() => this.removeItem(record.iId)}
        />
      )}
    ])

    this.state = {
      data: [],
      adjuntosRequisicion: [],
      loading: false,
      cotizacionId: 0,
      cotizacionPendiente: false,
    }
  }

  /**
   * Load
   *
   * @param {Number} cotizacionId
   */
  load = (cotizacionId) => {
    this.setState({
      visible: true,
      loading: true,
      data: [],
      cotizacionId: cotizacionId,
    })

    const query = {
      adjuntos: {
        attributes: ['iId', 'iIdArchivo'],
        model: 'ComCuadroComparativoAdjunto',
        include: [{ as: 'archivo', attributes: ['sDescripcion', 'dFechaHora'] }],
        where: {
          iIdCuadro: cotizacionId,
          iIdProveedor: Api.getProviderId(),
          iActivo: true
        },
      },

      firmas: {
        model: 'ComCuadroComparativoFirma',
        attributes: ['iId'],
        where: {
          iIdCuadro: cotizacionId,
          iIdUsuario: { $gt: 0 },
          iActivo: true,
        },
        limit: 1,
      },

      adjuntosRequisicion: {
        model: 'ReqRequisicionAdjunto',
        attributes: ['iId', 'iIdArchivo'],
        include: [
          {
            as: 'archivo',
            required: true,
            attributes: ['sDescripcion'],
          },
          {
            as: 'requisicion',
            required: true,
            attributes: [],
            include: [{
              as: 'cuadrosComparativos',
              required: true,
              attributes: [],
              where: {
                iId: cotizacionId,
              }
            }]
          },
        ],
        where: {
          iVisibleProveedor: true,
          iActivo: true,
        }
      }
    }

    Api.query.list(query)
      .then(response =>
        this.setState({
          loading: false,
          data: response.data.adjuntos || [],
          adjuntosRequisicion: response.data.adjuntosRequisicion || [],
          cotizacionPendiente: response.data.firmas.length === 0,
        })
      )
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * uploadFile
   *
   */
  uploadFile = (file) => {
    // subiendo ...
    const closeMessage = message.loading('Subiendo', 0);

    // actualizar la ui
    const closeLoadings = () => {
      this.setState({ loading: false });
      closeMessage();
    }

    // invocado al finalizar
    const onFinish = () => {
      closeLoadings();
      message.success('Listo');
      this.load(this.state.cotizacionId);
    }

    // invocado cuando ocurre algún error
    const onError = error => {
      closeLoadings();
      Exception.load(error).show()
    };

    Api.post('/upload/file', Api.form({ upload: file, tipo: 'WEB.PROVIDER.UPLOAD' }))
      .then(response =>
        Api.post(`/com/cotizaciones/adjuntos`, {
          iIdCuadro: this.state.cotizacionId,
          iIdProveedor: Api.getProviderId(),
          iIdArchivo: response.data.iId,
        })
      )
      .then(onFinish)
      .catch(onError);
  }

  /**
   * nuevoAdjunto
   */
  nuevoAdjunto = () => {
    var input = document.createElement('input');
    input.type = 'file';
    // input.accept = template.sFiltro;
    input.onchange = e => {
      if (input.files.length > 0) {
        this.uploadFile(input.files[0]);
      }
      input.value = null;
    };

    input.click();
  }

  /**
   * removeItem
   *
   */
  removeItem = (id) => {
    const closeLoading = message.loading('Eliminando...', 0)

    this.setState({ loading: true })
    Api.put(`/com/cotizaciones/adjuntos/${id}`, { iActivo: false })
      .then(() => {
        this.setState({
          loading: false,
          data: this.state.data.filter(item => item.iId !== id),
        })
        closeLoading()
      })
      .catch(error => {
        this.setState({ loading: false })
        closeLoading()
        Exception.load(error).show()
      })
  }

  /**
   * Render
   *
   */
  render() {
    const crud = (
      <Crud
        buttons={this.state.cotizacionPendiente ? ['add', 'reload'] : ['reload']}
        onReload={() => this.load(this.state.cotizacionId)}
        onAdd={this.nuevoAdjunto}
      />
    )

    return (
      <Modal
        title='ADJUNTOS'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: '70%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='close'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='Cerrar'
          />
        ]}
        children={
          <div>
            <Row gutter={8}>
              <Col span={12}>
                <Table
                  key='2'
                  rowKey='iId'
                  size='small'
                  loading={this.state.loading}
                  columns={[
                    {
                      title: 'NOMBRE', dataIndex: 'archivo.sDescripcion', width: '100%',
                      render: (_, record) => <span>
                        <a href={Api.to(`/upload/file/${record.iIdArchivo}`)} download={record.archivo.sDescripcion}>
                          {record.archivo.sDescripcion}
                        </a>
                      </span>
                    },
                  ]}
                  pagination={false}
                  dataSource={this.state.adjuntosRequisicion}
                  bordered={false}
                  title={() => (
                    <div>
                      <h4>Adjuntos compartidos</h4>
                      {crud}
                    </div>
                  )}
                />
              </Col>
              <Col span={12}>
                <Table
                  key='2'
                  rowKey='iId'
                  size='small'
                  loading={this.state.loading}
                  columns={this.columns}
                  pagination={false}
                  dataSource={this.state.data}
                  bordered={false}
                  title={() => (
                    <div>
                      <h4>Adjuntos de la cotización</h4>
                      {crud}
                    </div>
                  )}
                />
              </Col>
            </Row>
          </div>
        }
      />
    )
  }
}
